import { render, staticRenderFns } from "./CardsFilter.vue?vue&type=template&id=ea1b4a5a&scoped=true&"
import script from "./CardsFilter.vue?vue&type=script&lang=js&"
export * from "./CardsFilter.vue?vue&type=script&lang=js&"
import style0 from "./CardsFilter.vue?vue&type=style&index=0&id=ea1b4a5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea1b4a5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\src\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea1b4a5a')) {
      api.createRecord('ea1b4a5a', component.options)
    } else {
      api.reload('ea1b4a5a', component.options)
    }
    module.hot.accept("./CardsFilter.vue?vue&type=template&id=ea1b4a5a&scoped=true&", function () {
      api.rerender('ea1b4a5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "BuildABox/components/Filters/CardsFilter.vue"
export default component.exports